// extracted by mini-css-extract-plugin
module.exports = {"container":"VenueReviewsStile_container__tXpb4","colored":"VenueReviewsStile_colored__3HK3A","reviews_block":"VenueReviewsStile_reviews_block__6U3X3"};